import React, { useState } from 'react';
import { Trans } from 'react-i18next';

import { ContactUsModal } from '../../sideMenu/contactUs/ContactUsModal';
import { CONTACT_US_STEPS } from '../../sideMenu/contactUs/contactUs.constants';

import alertIcon from '../../../assets/petDemos/alert-error-red.svg';

import styles from './ErrorAlert.module.css';

const EMPTY_TEXT = '';
const CONTACT_US_REF = '#';

const ErrorAlert = ({ className = '' }) => {
  const [show, setShow] = useState(false);

  const handleContactClick = (event) => {
    event.preventDefault();
    setShow(true);
  };

  const handleClose = () => setShow(false);

  const ContactSupportText = (
    <a
      className={styles.link}
      href={CONTACT_US_REF}
      onClick={handleContactClick}
    >
      {EMPTY_TEXT}
    </a>
  );

  return (
    <>
      <div className={`${styles.container} ${className}`} role="alert">
        <img alt="" aria-hidden className={styles.icon} src={alertIcon} />

        <div className={styles.message}>
          <Trans
            components={{ a: ContactSupportText }}
            i18nKey="certificateLinking.errorAlert.message"
            ns="petDemos"
          />
        </div>
      </div>

      <ContactUsModal
        companyStep={CONTACT_US_STEPS.PPI_ONE_PACK}
        onClose={handleClose}
        show={show}
      />
    </>
  );
};

export { ErrorAlert };
